import axios from 'axios'

import store from '@/store'

const BASE_URL = process.env.VUE_APP_CLINICAL_CASE_API
const getToken = () => store?.getters?.getUserToken

/**
 * Pesquisar pelo documento
 * @param {object} DocumentId - id do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const getDocument = (DocumentId) => {
  return axios({
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/${DocumentId}`
  })
}

/**
 * Obter a lista de documentos
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const getDocuments = ({ params }) => {
  return axios({
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document?page=${params.page}&size=${params.size}&type=${params.type}`
  })
}

/**
 * Editar o Documento.
 * @param {object} DocId - id do Documento.
 * @param {object} docData - Os dados do consultor do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const editDocument = (docData, DocId) => {
  return axios({
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/${DocId}`,
    data: docData
  })
}

/**
 * Criar o Documento.
 * @param {object} DocData - Os dados do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const createDocument = (DocData) => {
  return axios({
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document`,
    data: DocData
  })
}

/**
 * Deletar o Documento com o ID especificado.
 * @param {string} DocId - O ID do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const deleteDocument = (DocId) => {
  return axios({
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/${DocId}`
  })
}

/**
 * Pesquisar pelo documento
 * @param {object} DocumentTypeId - id do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const getDocumentType = (DocumentTypeId) => {
  return axios({
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/type/${DocumentTypeId}`
  })
}

/**
 * Obter a lista de documentos
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const getDocumentsTypes = ({ params }) => {
  return axios({
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/type?page=${params.page}&size=${params.size}`
  })
}

/**
 * Editar o Documento.
 * @param {object} DocId - id do Documento.
 * @param {object} docData - Os dados do consultor do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const editDocumentType = (docData, DocId) => {
  return axios({
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/type/${DocId}`,
    data: docData
  })
}

/**
 * Criar o Documento.
 * @param {object} DocData - Os dados do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const createDocumentType = (DocData) => {
  return axios({
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/type`,
    data: DocData
  })
}

/**
 * Deletar o Documento com o ID especificado.
 * @param {string} DocId - O ID do documento.
 * @returns {Promise} - Uma promessa que retorna a resposta da solicitação.
 */
export const deleteDocumentType = (DocId) => {
  return axios({
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/type/${DocId}`
  })
}

export const insertFile = (docData, DocId) => {
  const formData = new FormData()
  formData.append('file', docData)
  return axios({
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/documents/${DocId}/file`,
    data: formData
  })
}

export const getFileDownload = (DocId) => {
  return axios({
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    url: `${BASE_URL}/document/file/${DocId}`,
    responseType: 'blob'
  })
}
